/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_Consent_MessageInputs */

const en_cookie_consent_message = /** @type {(inputs: Cookie_Consent_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We use cookies for essential functionality and optional analytics. You choose what to allow.`)
};

const de_cookie_consent_message = /** @type {(inputs: Cookie_Consent_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir verwenden Cookies für wesentliche Funktionen und optionale Analyse. Sie entscheiden, was Sie erlauben.`)
};

const fr_cookie_consent_message = /** @type {(inputs: Cookie_Consent_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous utilisons des cookies analytiques pour ameliorer votre experience.`)
};

const es_cookie_consent_message = /** @type {(inputs: Cookie_Consent_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usamos cookies de analisis para mejorar tu experiencia.`)
};

const it_cookie_consent_message = /** @type {(inputs: Cookie_Consent_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizziamo cookie di analisi per migliorare la tua esperienza.`)
};

const nl_cookie_consent_message = /** @type {(inputs: Cookie_Consent_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We gebruiken analytische cookies om uw ervaring te verbeteren.`)
};

const pl_cookie_consent_message = /** @type {(inputs: Cookie_Consent_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzywamy analitycznych plikow cookie, aby poprawic Twoje doswiadczenie.`)
};

const fi_cookie_consent_message = /** @type {(inputs: Cookie_Consent_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaytamme analytiikkaevaesteita kokemuksesi parantamiseksi.`)
};

const da_cookie_consent_message = /** @type {(inputs: Cookie_Consent_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi bruger analysecookies til at forbedre din oplevelse.`)
};

const sv_cookie_consent_message = /** @type {(inputs: Cookie_Consent_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi anvaender analyskakor foer att foerbaettra din upplevelse.`)
};

/**
* | output |
* | --- |
* | "We use cookies for essential functionality and optional analytics. You choose what to allow." |
*
* @param {Cookie_Consent_MessageInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cookie_consent_message = /** @type {((inputs?: Cookie_Consent_MessageInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Consent_MessageInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cookie_consent_message(inputs)
	if (locale === "fr") return fr_cookie_consent_message(inputs)
	if (locale === "es") return es_cookie_consent_message(inputs)
	if (locale === "it") return it_cookie_consent_message(inputs)
	if (locale === "nl") return nl_cookie_consent_message(inputs)
	if (locale === "pl") return pl_cookie_consent_message(inputs)
	if (locale === "fi") return fi_cookie_consent_message(inputs)
	if (locale === "da") return da_cookie_consent_message(inputs)
	if (locale === "sv") return sv_cookie_consent_message(inputs)
	return en_cookie_consent_message(inputs)
});